import ProformaList from "@components/modules/invoices/ProformaList";
import { NavigationFinance } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Proforma invoices`} navigation={<NavigationFinance />}>
    <DemoModule module={Modules.InvoicesProformaInvoices}>
      <ProformaList />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/invoices/proforma-invoices/")({
  component: Page,
});
